import { isDesktop, isIOS, isMobile, isSafari } from 'react-device-detect';

export const isMobilePlatform = isMobile;
export const isDesktopPlatform = isDesktop;
export const isIOSPlatform = isIOS;
export const isSafariPlatform = isSafari;
